import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import classnames from 'classnames';
import { ScrollIntoView, Delayed } from '@grandvisionhq/common';
import { Heading, Button, Text } from '@grandvisionhq/elements';
import { Spinner, Alert } from '@grandvisionhq/iris-ui';
import { useIntl } from '@grandvisionhq/state';
import '@grandvisionhq/bloomreach';
import '@grandvisionhq/graphql';
import '@grandvisionhq/svc-tealium/events';
import '@grandvisionhq/utils';
import '@grandvisionhq/analytics';
import '../../../../queries/get-availability-stores-nearby.js';
import '@grandvisionhq/stores-v2';
import '../../../../queries/book-appointment.js';
import '../../../../queries/book-appointment-by-id.js';
import '../../../../queries/get-user.js';
import '../../../../queries/get-calendar-availability-by-id.js';
import '../../../../queries/get-store-offer-by-code.js';
import '../../../../queries/get-store-offer-by-id.js';
import '../../../../queries/get-store-opening-times.js';
import '../../../../queries/get-store-opening-times-by-id.js';
import '../../../../queries/get-time-slots-by-id.js';
import 'date-fns';
import '../../../BookAppointment/context/appointment-slots.js';
import '../../../BookAppointment/queries/get-book-appointment-store-by-id.js';
import '../../../BookAppointment/queries/get-book-appointment-type.js';
import '../../../../components/AppointmentConfirmation/AppointmentConfirmation.js';
import '../../../../components/AppointmentCustomerForm/AppointmentCustomerFormContainer.js';
import { Variant } from '../../../../components/NoTimeSlots/types.js';
import AvailabilityCalendarContainer from '../../../../components/AvailabilityCalendar/AvailabilityCalendarContainer.js';
import '@grandvisionhq/icons';
import NoTimeSlotsContainer from '../../../../components/NoTimeSlots/NoTimeSlotsContainer.js';
import PreferredTimeContainer from '../../../../components/PreferredTime/PreferredTimeContainer.js';
import TimeSlotsContainer from '../../../../components/TimeSlots/TimeSlotsContainer.js';
import '@grandvisionhq/auth';
import '../../../../components/StoreFinder/StoreFinderContainer.js';
import '@grandvisionhq/locations';
import '../../../../context/WhatStepSlotContext/WhatStepSlotContext.js';
import DateAndTimeContainer from '../../../../components/DateAndTime/DateAndTimeContainer.js';
import '../../../../components/Navigation/steps.js';
import '@grandvisionhq/lib-utils-html';
import '@grandvisionhq/frk-routing';
import '../../../../components/ClientSessionManager/ClientSessionManager.js';

const RescheduleAppointmentRoot = (_param)=>{
    var { className , labels , cancelAppointmentRoute , noTimeSlotsVariant , timeSlots , appointment , loading , returnPath , calendarLoading , calendarWeekCount , calendarWeekDate , calendarClosedDates , calendarAvailability , hasNoTimeSlotsAvailableInCalendar , selectedDate , timeSlotsLoading , nextAvailableDate , noMoreAvailabilityUntilDate , selectedTimeSlot , hasError , buttonState , showOtherTimeSlots , otherTimeSlots , onCalendarWeeksChange , onSelectDate , onSelectTime , noTimeSlotsAction , onToggleOtherTimeSlots , onRescheduleButtonClick , onPreferredTimeClick , onPreferredTimeFilterClick  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "className",
        "labels",
        "cancelAppointmentRoute",
        "noTimeSlotsVariant",
        "timeSlots",
        "appointment",
        "loading",
        "returnPath",
        "calendarLoading",
        "calendarWeekCount",
        "calendarWeekDate",
        "calendarClosedDates",
        "calendarAvailability",
        "hasNoTimeSlotsAvailableInCalendar",
        "selectedDate",
        "timeSlotsLoading",
        "nextAvailableDate",
        "noMoreAvailabilityUntilDate",
        "selectedTimeSlot",
        "hasError",
        "buttonState",
        "showOtherTimeSlots",
        "otherTimeSlots",
        "onCalendarWeeksChange",
        "onSelectDate",
        "onSelectTime",
        "noTimeSlotsAction",
        "onToggleOtherTimeSlots",
        "onRescheduleButtonClick",
        "onPreferredTimeClick",
        "onPreferredTimeFilterClick"
    ]);
    var ref, ref1;
    const { getLabel  } = useIntl();
    if (loading) {
        return /*#__PURE__*/ React.createElement("div", {
            className: "reschedule-appointment__loader"
        }, /*#__PURE__*/ React.createElement(Spinner, {
            "aria-label": getLabel('common.loadingText')
        }));
    }
    const noTimeSlotsComponent = hasNoTimeSlotsAvailableInCalendar ? /*#__PURE__*/ React.createElement(NoTimeSlotsContainer, {
        variant: noTimeSlotsVariant,
        action: noTimeSlotsAction,
        nextAvailableDate: nextAvailableDate,
        noAvailabilityUntilDate: noMoreAvailabilityUntilDate
    }) : null;
    if (!appointment) {
        return null;
    }
    const hasTimeSlots = timeSlots.length > 0;
    const hasOtherTimeSlots = otherTimeSlots.length > 0;
    return /*#__PURE__*/ React.createElement("div", swcHelpers.extends({}, rest, {
        className: classnames('reschedule-appointment', className)
    }), /*#__PURE__*/ React.createElement("section", {
        className: "reschedule-appointment__current-appointment"
    }, /*#__PURE__*/ React.createElement("h4", {
        className: "reschedule-appointment__section-title"
    }, labels.currentAppointment), /*#__PURE__*/ React.createElement(DateAndTimeContainer, {
        date: appointment.startTime,
        startTime: appointment.startTime,
        duration: (ref = appointment.appointmentType) === null || ref === void 0 ? void 0 : ref.duration,
        placeholder: labels.noAppointment
    })), /*#__PURE__*/ React.createElement(Heading, {
        component: "h3",
        variant: "smallest",
        className: "reschedule-appointment__title"
    }, labels.title), /*#__PURE__*/ React.createElement(PreferredTimeContainer, {
        onPreferredTimeClick: onPreferredTimeClick,
        onPreferredTimeFilterClick: onPreferredTimeFilterClick,
        calendar: /*#__PURE__*/ React.createElement(AvailabilityCalendarContainer, {
            "aria-controls": "reschedule-appointment__timeslots",
            loading: calendarLoading,
            weekCount: calendarWeekCount,
            weekDate: calendarWeekDate,
            closedDates: calendarClosedDates,
            availability: calendarAvailability,
            selectedDate: selectedDate,
            onChangeWeeks: onCalendarWeeksChange,
            onSelectDate: onSelectDate,
            noTimeSlots: noTimeSlotsComponent
        })
    }), /*#__PURE__*/ React.createElement("section", {
        id: "reschedule-appointment__timeslots",
        "aria-live": "polite"
    }, noTimeSlotsVariant === Variant.none ? /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("h4", {
        className: "reschedule-appointment__section-title"
    }, labels.selectATime), /*#__PURE__*/ React.createElement(TimeSlotsContainer, {
        loading: timeSlotsLoading,
        slots: timeSlots,
        selected: selectedTimeSlot,
        onSelectTime: onSelectTime
    })) : /*#__PURE__*/ React.createElement(React.Fragment, null, !hasNoTimeSlotsAvailableInCalendar ? /*#__PURE__*/ React.createElement(Alert, {
        className: "alert-m-default no-time-slots",
        variant: noTimeSlotsVariant === Variant.error ? 'warning' : 'info'
    }, /*#__PURE__*/ React.createElement(NoTimeSlotsContainer, {
        variant: noTimeSlotsVariant,
        action: noTimeSlotsAction,
        nextAvailableDate: nextAvailableDate,
        noAvailabilityUntilDate: noMoreAvailabilityUntilDate
    })) : null), hasOtherTimeSlots && /*#__PURE__*/ React.createElement(React.Fragment, null, hasTimeSlots && /*#__PURE__*/ React.createElement(Button, {
        className: "reschedule-appointment__show-other-time-slots",
        variant: "ghost",
        onClick: onToggleOtherTimeSlots
    }, showOtherTimeSlots ? labels.hideOtherTimeSlots : labels.showOtherTimeSlots), showOtherTimeSlots && /*#__PURE__*/ React.createElement("div", {
        className: "reschedule-appointment__other-time-slots"
    }, /*#__PURE__*/ React.createElement(ScrollIntoView, null, !hasTimeSlots && /*#__PURE__*/ React.createElement(Heading, {
        component: "h4",
        variant: "subheading1",
        className: "reschedule-appointment__section-title"
    }, labels.otherTimeSlots), /*#__PURE__*/ React.createElement(TimeSlotsContainer, {
        loading: timeSlotsLoading,
        slots: otherTimeSlots,
        onSelectTime: onSelectTime
    }))))), /*#__PURE__*/ React.createElement("section", null, /*#__PURE__*/ React.createElement("h4", {
        className: "reschedule-appointment__section-title"
    }, labels.selectedDateAndTime), /*#__PURE__*/ React.createElement(DateAndTimeContainer, {
        placeholder: labels.selectADateAndTime,
        date: selectedDate,
        startTime: selectedTimeSlot === null || selectedTimeSlot === void 0 ? void 0 : selectedTimeSlot.from,
        duration: (ref1 = appointment.appointmentType) === null || ref1 === void 0 ? void 0 : ref1.duration
    })), hasError && /*#__PURE__*/ React.createElement(Alert, {
        variant: "warning",
        title: labels.errorTitle,
        className: "alert-m-default"
    }, labels.errorMessage), /*#__PURE__*/ React.createElement("div", {
        className: "reschedule-appointment__cta"
    }, /*#__PURE__*/ React.createElement(Button, {
        variant: "solid",
        onClick: onRescheduleButtonClick,
        disabled: buttonState.disabled,
        loading: buttonState.loading
    }, labels.rescheduleAppointment), /*#__PURE__*/ React.createElement("div", {
        className: "reschedule-appointment__close-link"
    }, /*#__PURE__*/ React.createElement("a", {
        href: returnPath
    }, labels.close))), /*#__PURE__*/ React.createElement("footer", {
        className: "reschedule-appointment__footer"
    }, /*#__PURE__*/ React.createElement(Text, null, labels.cantFindSlot, " ", /*#__PURE__*/ React.createElement("a", {
        href: cancelAppointmentRoute
    }, labels.cancelYourAppointment)), buttonState.loading && /*#__PURE__*/ React.createElement(Delayed, {
        delay: 2500,
        scrollIntoView: true
    }, /*#__PURE__*/ React.createElement(Text, {
        color: "text-secondary",
        align: "center"
    }, labels.slowLoadingIndication))));
};

export { RescheduleAppointmentRoot as default };
//# sourceMappingURL=RescheduleAppointment.js.map
